export const NO_STUDENT_INFO_FOUND = "No student information found!"